import { createFileRoute } from '@tanstack/react-router';
import { Cadastro } from '@/features/login/page/Cadastro';

export const Route = createFileRoute('/auth/cadastro')({
    component: Cadastro,
    validateSearch: (search: Record<string, any>): { representanteIdpk?: string } => ({
        representanteIdpk: search?.representanteIdpk,
    }),
});
